
import './App.css';

import { BrowserRouter, Routes, Route} from "react-router-dom";



//Components
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

//Pages
import Home from "./pages/Home";
import Manufacture from "./pages/Manufacture";
import Conditionning from './pages/Conditionning';
import Quality from "./pages/Quality";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
// import Notification from "./pages/Notification";
//<Route path="/notification" element={<Notification />} />

function App() {
  return (
<BrowserRouter
  basename="/"
  future={{
    v7_startTransition: true,
    v7_relativeSplatPath: true,
  }}
>
<div className="scroll-smooth">
  <Navbar />
  <Routes>
    <Route index path="/" element={<Home />} />
    <Route path="/manufacture" element={<Manufacture />} />
    <Route path="/conditionning" element={<Conditionning />} />
    
    <Route path="/quality" element={<Quality />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
  <Footer/>
</div>
</BrowserRouter>
  );
}

export default App;
